import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CheckoutForm.css';

interface LocationState {
  bookingData: {
    checkIn: Date;
    checkOut: Date;
    nights: number;
    subtotal: number;
    discountAmount: number;
    taxAmount: number;
    total: number;
  };
}

const CheckoutForm: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!state?.bookingData) {
      navigate('/');
      return;
    }

    const redirectToCheckout = async () => {
      try {
        const response = await fetch('https://api.theacademicloft.com/create-checkout-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            checkIn: state.bookingData.checkIn.toISOString().split('T')[0],
            checkOut: state.bookingData.checkOut.toISOString().split('T')[0],
            nights: state.bookingData.nights,
            subtotal: state.bookingData.subtotal,
            discountAmount: state.bookingData.discountAmount,
            taxAmount: state.bookingData.taxAmount,
            total: state.bookingData.total
          })
        });

        const data = await response.json();

        if (response.ok && data.url) {
          // Redirect to Stripe-hosted checkout page
          window.location.href = data.url;
        } else {
          throw new Error(data.error || 'Failed to create checkout session');
        }
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to initialize checkout';
        setError(errorMessage);
        setLoading(false);
      }
    };

    redirectToCheckout();
  }, [state, navigate]);

  if (error) {
    return (
      <div className="checkout-error">
        <h2>Unable to process checkout</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')} className="back-button">
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="checkout-container">
      <div className="checkout-loading">
        <h2>Redirecting to secure checkout...</h2>
        <p>Please wait while we prepare your payment.</p>
      </div>
    </div>
  );
};

export default CheckoutForm;
